module.exports = __webpack_public_path__ + "img/integratedLogo2.ecf7c1fb.png";